/*
File: 包含分页的表格
Author: SimonLu<luzuoqing@huya.com>
Date: 2020-03-17
*/

import React, { useEffect, useCallback, useState, useMemo } from 'react'
import { useAction } from '@/hooks/useAction'
import { Button, DatePicker, Table  } from 'antd'
import * as R from 'ramda'
import {usePagination} from '../../hooks/usePagination'

const mockData = {
  types: [{type: 1, name: '主播使用时长', unit: '分钟', maxServiceFee: 120}, {type: 2, name: '使用小程序流水', unit: '金豆', maxServiceFee: 120}],
  serviceBacks: [
    {
      orderId: '19092114424499999991',
      extInfo: {
        name: '测试创建扩展2',
        extUuid: '31233',
      },
      time: '2019-08',
      fee: 200,
      condition: {
        type: 0,
        condition: 100,
      },
    },
    {
      orderId: '190921144244923191',
      extInfo: {
        name: '测试创建扩展',
        extUuid: '7zp9wg9s',
      },
      time: '2019-08',
      fee: 200,
      condition: {
        type: 0,
        condition: 100,
      },
    },
  ],
  sum: 2000,
}

function PaginationTable({ fetcher, columns, transformer = R.prop('data'), reFetchCnt }) {
  const [{ isLoading, respData, error }, performAction] = useAction(fetcher)

  const [pagination, paginationDispatch] = usePagination()

  const query = () => performAction({
    page: pagination.current,
    pageSize: pagination.pageSize,
  })

  useEffect(() => {
    // console.log('pagination', pagination)
    query()
  }, [pagination, reFetchCnt])

  return (
    <div style={{ backgroundColor: 'white', borderRadius: '4px', paddingTop: '0' }}>
      <Table
        columns={columns}
        dataSource={transformer(respData) || []}
        // dataSource={transformer(mockData) || []}
        pagination={{
          ...pagination,
          total: R.prop('total', respData),
          onChange: page => paginationDispatch({
            type: 'update',
            payload: { current: page },
          }),
        }}
        loading={isLoading}
      >
      </Table>
    </div>
  )
}

export default PaginationTable
